import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {

    static targets = ["modal", "title", "body"]

    declare readonly modalTarget: HTMLElement
    declare readonly titleTarget: HTMLElement
    declare readonly bodyTarget: HTMLElement

    private modalInstance: Modal | null = null
    private boundClick!: (e: Event) => void

    connect(): void {
        this.boundClick = (e: Event) => {
            const btn = (e.target as Element).closest<HTMLElement>('[data-sede-items-url]')
            if (!btn || !this.element.contains(btn)) return
            const url   = btn.dataset.sedeItemsUrl   ?? ''
            const title = btn.dataset.sedeItemsTitle ?? ''
            this.show({ params: { url, title } })
        }
        // Capture phase: fires before any bubbling handler, regardless of DataTable row insertion
        document.addEventListener('click', this.boundClick, true)
    }

    disconnect(): void {
        document.removeEventListener('click', this.boundClick, true)
    }

    private getModal(): Modal {
        if (!this.modalInstance) {
            this.modalInstance = new Modal(this.modalTarget)
        }
        return this.modalInstance
    }

    async show({ params }: { params: { url: string; title: string } }): Promise<void> {

        this.titleTarget.textContent = params.title
        this.bodyTarget.innerHTML    = `
            <div class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
            </div>`

        this.getModal().show()

        try {
            const res  = await fetch(params.url)
            const data = await res.json()
            this.render(data)
        } catch {
            this.bodyTarget.innerHTML =
                '<p class="text-danger text-center py-3"><i class="bi bi-exclamation-triangle me-1"></i>Error al cargar los datos.</p>'
        }
    }

    private render(data: { type: string; items: any[] }): void {

        if (data.items.length === 0) {
            this.bodyTarget.innerHTML =
                '<p class="text-muted text-center py-3">No hay elementos para mostrar.</p>'
            return
        }

        let html = '<div class="table-responsive"><table class="table table-sm table-striped align-middle mb-0">'

        if (data.type === 'users') {

            html += `<thead class="table-light">
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Correo</th>
                            <th>Teléfono</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                     </thead><tbody>`
            let number = 1;
            for (const item of data.items) {
                const badge  = item.active
                    ? '<span class="badge bg-success">Activo</span>'
                    : '<span class="badge bg-secondary">Inactivo</span>'
                const editBtn = item.editUrl
                    ? `<a href="${item.editUrl}" class="btn btn-warning btn-sm" target="_blank">
                           <i class="bi bi-pencil"></i>
                       </a>`
                    : ''
                const avatar = item.image
                    ? `<img src="${item.image}" class="rounded-circle me-2 dt-avatar" style="width:32px;height:32px;object-fit:cover;" alt="">`
                    : `<span class="rounded-circle bg-secondary d-inline-flex align-items-center justify-content-center me-2" style="width:32px;height:32px;font-size:13px;color:#fff;">${this.esc(item.name.charAt(0).toUpperCase())}</span>`
                html += `<tr>
                    <td>${number++}</td>
                    <td><div class="d-flex align-items-center">${avatar}${this.esc(item.name)}</div></td>
                    <td><small class="text-muted">${this.esc(item.email)}</small></td>
                    <td><small>${this.esc(item.phone ?? '')}</small></td>
                    <td>${badge}</td>
                    <td class="text-end">${editBtn}</td>
                </tr>`
            }

        } else {

            html += `<thead class="table-light">
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Colegio</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                     </thead><tbody>`
            let number = 1;
            for (const item of data.items) {
                const badge  = item.active
                    ? '<span class="badge bg-success">Activo</span>'
                    : '<span class="badge bg-secondary">Inactivo</span>'
                const editBtn = item.editUrl
                    ? `<a href="${item.editUrl}" class="btn btn-warning btn-sm" target="_blank">
                           <i class="bi bi-pencil"></i>
                       </a>`
                    : ''
                const avatar = item.image
                    ? `<img src="${item.image}" class="rounded-circle me-2 dt-avatar" style="width:32px;height:32px;object-fit:cover;" alt="">`
                    : `<span class="rounded-circle bg-secondary d-inline-flex align-items-center justify-content-center me-2" style="width:32px;height:32px;font-size:13px;color:#fff;">${this.esc(item.name.charAt(0).toUpperCase())}</span>`
                html += `<tr>
                    <td>${number++}</td>
                    <td><div class="d-flex align-items-center">${avatar}${this.esc(item.name)}</div></td>
                    <td><small class="text-muted">${this.esc(item.colegio ?? '')}</small></td>
                    <td>${badge}</td>
                    <td class="text-end">${editBtn}</td>
                </tr>`
            }
        }

        html += '</tbody></table></div>'
        this.bodyTarget.innerHTML = html
    }

    private esc(str: string): string {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
    }
}
